import { render, staticRenderFns } from "./identityAuthentication.vue?vue&type=template&id=5712ead5&scoped=true"
import script from "./identityAuthentication.vue?vue&type=script&lang=js"
export * from "./identityAuthentication.vue?vue&type=script&lang=js"
import style0 from "./identityAuthentication.vue?vue&type=style&index=0&id=5712ead5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712ead5",
  null
  
)

export default component.exports